export const REDUX_STORE_VERSION =
  Number(process.env.REDUX_STORE_VERSION) ?? -1;
export const IS_DEV_MODE = process.env.NODE_ENV === 'development';
export const RU_LANG_SUPPORT = !!process.env.RU_LANG_SUPPORT;
export const BITRIX24_WEBHOOK_ADD_LEAD_SEKRET_KEY =
  process.env.BITRIX24_WEBHOOK_ADD_LEAD_SEKRET_KEY;
export const WHITE_LABEL = !!process.env.WHITE_LABEL;
export const FORCE_VIEW_GUARANTEE = !!process.env.FORCE_VIEW_GUARANTEE;
const isQblocksHost =
  typeof window !== 'undefined' &&
  window.location.hostname.includes('qblocks.ai');
export const SDK_API_HOST = isQblocksHost
  ? 'https://edu.qblocks.ai/api/face-detector'
  : process.env.SDK_API_HOST || '/api/face-detector';
export const SDK_INTEGRATE_TOKEN = process.env.SDK_INTEGRATE_TOKEN;
export const SDK_PLAYER_SESSION = 'PLAYER_SESSION';
